import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Icon, Col, Row, Select, Input } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import CatalogosRequest from '../../services/Catalogos';
import FuenteDemandaRequest from '../../services/FuenteDemanda';
import moment from 'moment'
import 'moment/locale/es';
import * as Excel from "exceljs";
import { saveAs } from "file-saver";
import ResponsiveCard from '../Common/ResponsiveCard';
moment.locale('es')
const { Option } = Select;

/**
 * Clase para ver el proceso de calendario pedidos
 */
export default class FuenteDemanda extends Component {
    state = {
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        drivesSelected: null,
        arrCategorias: [],
        filterText: "",
        cargando: false,
        modo: null,
        tipo_modal: null,
        modalCategorias: false,
        modalCalendario: false,
        disableDeleteFilters: true,
        disableApplyFilters: true,
        arrFuenteDemanda: [],
        arrFuenteDemandaCopy: [],
        categoriaSelected: null,
        variablesModeloPedido: undefined,
        diasFuenteDemanda: [],
    }

    /**
     * Comportamiento del componente al mostrar la
     * fuente de demanda
     */
    componentDidMount = () => {
        let state = { ...this.state }
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                return CategoriasRequest.ListarCategorias();
            })
            .then(response => {
                state.arrCategorias = response.data;
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrFuenteDemandaCopy = state.arrFuenteDemanda
        if (value) {
            arrFuenteDemandaCopy = arrFuenteDemandaCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo_codigo)
                    || sanitizerTexto(value, obj.articulo_descripcion)
            })
        }
        state.arrFuenteDemandaCopy = arrFuenteDemandaCopy
        this.setState(state);
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = null;
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = null;
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = null;
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
            if (['Administrador', 'SuperAdmin'].includes(localStorage.getItem("role"))) {
                CatalogosRequest.ListarSitios(value).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los drives de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            } else {
                CatalogosRequest.ListarSitiosPlazaUsuario(value, localStorage.getItem("id_user")).then(response => {
                    state.arrDrives = response.data
                    this.setState(state)
                }).catch(err => {
                    openNotification(
                        "Ha ocurrido un error al cargar los drives de la plaza.",
                        "Error al cargar drives",
                        false
                    )
                })
            }

        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.disableApplyFilters = true
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.drivesSelected = null;
        } else {
            state.drivesSelected = value
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de categoría
     * @param: value. valor del id del categoría
     * @return: nada.
     */
    handleChangeCategoria = (value) => {
        let state = { ...this.state }
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.categoriaSelected = null;
            state.disableApplyFilters = true
            state.tipo_modelo = null;
        } else {
            state.categoriaSelected = value
            state.disableApplyFilters = false
            for (let index = 0; index < state.arrCategorias.length; index++) {
                const element = state.arrCategorias[index];
                if (value === element.id) state.tipo_modelo = element.tipo_modelo
            }
        }

        this.setState(state)
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = null;
        state.filterText = "";
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
     * Función que se ejecuta para cargar 
     * la fuente de demanda
     */
    cargarFuenteDemanda = () => {
        let state = { ...this.state }
        let a = state.drivesSelected;
        let b = state.tipo_modelo;
        let c = state.categoriaSelected;
        state.cargando = true;
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        this.setState(state, () => {
            FuenteDemandaRequest.ListarFuenteDemanda(a, b, c)
                .then(response => {
                    state.arrFuenteDemanda = response.data
                    state.arrFuenteDemandaCopy = response.data
                    return FuenteDemandaRequest.ListarVariablesFuente(a, b, c);
                })
                .then(response => {
                    state.cargando = false;
                    state.disableApplyFilters = false;
                    state.disableDeleteFilters = false;
                    if (response.data.length) {
                        state.variablesModeloPedido = response.data[0].modelo_pedido_filtrado[0]
                    }
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({
                        cargando: false,
                        disableApplyFilters: false,
                        disableDeleteFilters: false
                    })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        "Error al listar fuente de demanda",
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta para descargar 
     * la fuente de demanda
     */
    descargarFuenteDemanda = () => {
        let state = { ...this.state }
        let variables = state.variablesModeloPedido
        let dia_actual = moment(new Date()).format("DD/MM/YYYY")
        let dia_hoy = moment(new Date())
        state.diasFuenteDemanda = [];

        for (let index = 1; index < 22; index++) {
            state.diasFuenteDemanda.push(moment(dia_hoy).subtract(index, 'd').format('YYYY-MM-DD'))
        }

        state.diasFuenteDemanda.reverse();

        for (let index = 0; index < state.arrFuenteDemanda.length; index++) {
            const element = state.arrFuenteDemanda[index];
            element.demanda_final = [];
            if (element.estatus === 2) { //Cuando el estatus es Off
                for (let index = 0; index < 21; index++) {
                    element.demanda_final.push({ cantidad: '-', fecha: state.diasFuenteDemanda[index] })
                }
            }

            if (element.estatus === 3) { //Cuando el estatus es Nuevo
                if (element.demanda_diaria.length === 21) {
                    element.demanda_final = element.demanda_diaria
                } else {
                    for (let index = 0; index < state.diasFuenteDemanda.length; index++) {
                        const dia_for = state.diasFuenteDemanda[index];
                        let filter_diaria = element.demanda_diaria.filter(item => item.fecha === dia_for)
                        let filter_excel = element.demanda_excel.filter(item => item.fecha === dia_for)
                        if (filter_diaria.length) {
                            element.demanda_final.push(filter_diaria[0])
                        } else if (filter_excel.length) {
                            element.demanda_final.push(filter_excel[0])
                        } else {
                            element.demanda_final.push({ cantidad: '-', fecha: dia_for })
                        }
                    }
                }
            }

            if (element.estatus === 1 || element.estatus === 4) { //Cuando el estatus es On o Promoción
                for (let index = 0; index < state.diasFuenteDemanda.length; index++) {
                    let dia_for = state.diasFuenteDemanda[index]
                    let item_actual_filter = element.demanda_excel.filter(item => item.fecha === dia_for)
                    if (item_actual_filter.length) {
                        element.demanda_final.push(item_actual_filter[0])
                    } else {
                        element.demanda_final.push({ cantidad: '-', fecha: dia_for })
                    }
                }
            }
        }

        let datos_variables = {
            'Modelo': variables.tipo_modelo_nombre,
            'Día de consulta': dia_actual,
            'Tiempo de entrega': variables.variables_modelo.tiempo_entrega,
            'Tiempo máx. de entrega': variables.variables_modelo.tiempo_max_entrega,
            'Frecuencia de visita semanal': variables.variables_modelo.frecuencia_visita,
            'Incremento por eventualidad': variables.variables_modelo.incremento_eventualidad.valor
        }

        var wb = new Excel.Workbook();
        var ws = wb.addWorksheet('Fuente de demanda');

        const fontStyle = {
            name: 'Arial',
            color: { argb: 'FFFFFFFF' },
            bold: true,
            size: 12
        }
        const alignmentStyle = {
            vertical: 'middle',
            horizontal: 'center'
        }
        const borderStyle = {
            top: { color: { rgb: '110, 105, 105' } },
            left: { color: { rgb: '110, 105, 105' } },
            bottom: { color: { rgb: '110, 105, 105' } },
            right: { color: { rgb: '110, 105, 105' } }
        }
        const fillStyle = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '506e6969' }
        }
        const styleFormat = {
            font: fontStyle,
            alignment: alignmentStyle,
            border: borderStyle,
            fill: fillStyle
        }

        ws.columns = [
            { key: 'A', width: 35 },
            { key: 'B', width: 15 },
            { key: 'C', width: 5 },
            { header: 'Código', key: 'codigo', width: 15 },
            { header: 'Descripción', key: 'descripcion', width: 50 },
            { header: 'UDMP', key: 'udmp', width: 14 },
            { header: 'Estatus', key: 'estatus_nombre', width: 20 },
            { header: 'Inv. interno', key: 'inv_interno', width: 17 },
            { header: 'Inv. externo', key: 'inv_externo', width: 17 },
            { header: 'Pedidos en tránsito', key: 'pedidos_transito', width: 25 },
            { header: 'Cantidad en pedidos', key: 'cantidad_pedidos', width: 25 },
            { header: 'Minimo estándar BP', key: 'minimo_estandar', width: 25 },
            { header: 'Inv. teórico', key: 'inv_teorico', width: 17 },
            { header: 'Días inv. teórico', key: 'dias_teorico', width: 25 },
            { header: moment(new Date(state.diasFuenteDemanda[0])).utcOffset(0, false).format("DD-MM"), key: 'dia_0', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[1])).utcOffset(0, false).format("DD-MM"), key: 'dia_1', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[2])).utcOffset(0, false).format("DD-MM"), key: 'dia_2', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[3])).utcOffset(0, false).format("DD-MM"), key: 'dia_3', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[4])).utcOffset(0, false).format("DD-MM"), key: 'dia_4', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[5])).utcOffset(0, false).format("DD-MM"), key: 'dia_5', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[6])).utcOffset(0, false).format("DD-MM"), key: 'dia_6', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[7])).utcOffset(0, false).format("DD-MM"), key: 'dia_7', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[8])).utcOffset(0, false).format("DD-MM"), key: 'dia_8', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[9])).utcOffset(0, false).format("DD-MM"), key: 'dia_9', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[10])).utcOffset(0, false).format("DD-MM"), key: 'dia_10', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[11])).utcOffset(0, false).format("DD-MM"), key: 'dia_11', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[12])).utcOffset(0, false).format("DD-MM"), key: 'dia_12', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[13])).utcOffset(0, false).format("DD-MM"), key: 'dia_13', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[14])).utcOffset(0, false).format("DD-MM"), key: 'dia_14', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[15])).utcOffset(0, false).format("DD-MM"), key: 'dia_15', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[16])).utcOffset(0, false).format("DD-MM"), key: 'dia_16', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[17])).utcOffset(0, false).format("DD-MM"), key: 'dia_17', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[18])).utcOffset(0, false).format("DD-MM"), key: 'dia_18', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[19])).utcOffset(0, false).format("DD-MM"), key: 'dia_19', width: 10 },
            { header: moment(new Date(state.diasFuenteDemanda[20])).utcOffset(0, false).format("DD-MM"), key: 'dia_20', width: 10 },
            { header: 'Demanda promedio', key: 'demanda_promedio', width: 25 },
            { header: 'Pedido sugerido', key: 'pedido_sugerido', width: 22 },
            { header: 'Stock de seguridad', key: 'stock_seguridad', width: 25 }
        ]

        ws.getRow(1).height = 20;

        ws.getCell('D1').style = styleFormat;
        ws.getCell('E1').style = styleFormat;
        ws.getCell('F1').style = styleFormat;
        ws.getCell('G1').style = styleFormat;
        ws.getCell('H1').style = styleFormat;
        ws.getCell('I1').style = styleFormat;
        ws.getCell('J1').style = styleFormat;
        ws.getCell('K1').style = styleFormat;
        ws.getCell('L1').style = styleFormat;
        ws.getCell('M1').style = styleFormat;
        ws.getCell('N1').style = styleFormat;
        ws.getCell('O1').style = styleFormat;
        ws.getCell('P1').style = styleFormat;
        ws.getCell('Q1').style = styleFormat;
        ws.getCell('R1').style = styleFormat;
        ws.getCell('S1').style = styleFormat;
        ws.getCell('T1').style = styleFormat;
        ws.getCell('U1').style = styleFormat;
        ws.getCell('V1').style = styleFormat;
        ws.getCell('W1').style = styleFormat;
        ws.getCell('X1').style = styleFormat;
        ws.getCell('Y1').style = styleFormat;
        ws.getCell('Z1').style = styleFormat;
        ws.getCell('AA1').style = styleFormat;
        ws.getCell('AB1').style = styleFormat;
        ws.getCell('AC1').style = styleFormat;
        ws.getCell('AD1').style = styleFormat;
        ws.getCell('AE1').style = styleFormat;
        ws.getCell('AF1').style = styleFormat;
        ws.getCell('AG1').style = styleFormat;
        ws.getCell('AH1').style = styleFormat;
        ws.getCell('AI1').style = styleFormat;
        ws.getCell('AJ1').style = styleFormat;
        ws.getCell('AK1').style = styleFormat;
        ws.getCell('AL1').style = styleFormat;

        state.arrFuenteDemanda.forEach((obj, index) => {
            ws.addRow({
                codigo: obj.articulo_codigo,
                descripcion: obj.articulo_descripcion,
                demanda_promedio: obj.demanda_promedio,
                estatus_nombre: obj.estatus_nombre,
                udmp: obj.unidad_medida,
                inv_interno: obj.inv_interno,
                inv_externo: obj.inv_externo,
                inv_teorico: obj.inv_teorico,
                pedido_sugerido: obj.pedido_sugerido,
                pedidos_transito: obj.pedidos_en_transito,
                cantidad_pedidos: obj.cantidad_en_pedidos,
                minimo_estandar: obj.minimo_estandar_bp,
                dias_teorico: obj.dias_inv_teorico,
                stock_seguridad: obj.stock_seguridad,
                dia_0: obj.demanda_final[0].cantidad,
                dia_1: obj.demanda_final[1].cantidad,
                dia_2: obj.demanda_final[2].cantidad,
                dia_3: obj.demanda_final[3].cantidad,
                dia_4: obj.demanda_final[4].cantidad,
                dia_5: obj.demanda_final[5].cantidad,
                dia_6: obj.demanda_final[6].cantidad,
                dia_7: obj.demanda_final[7].cantidad,
                dia_8: obj.demanda_final[8].cantidad,
                dia_9: obj.demanda_final[9].cantidad,
                dia_10: obj.demanda_final[10].cantidad,
                dia_11: obj.demanda_final[11].cantidad,
                dia_12: obj.demanda_final[12].cantidad,
                dia_13: obj.demanda_final[13].cantidad,
                dia_14: obj.demanda_final[14].cantidad,
                dia_15: obj.demanda_final[15].cantidad,
                dia_16: obj.demanda_final[16].cantidad,
                dia_17: obj.demanda_final[17].cantidad,
                dia_18: obj.demanda_final[18].cantidad,
                dia_19: obj.demanda_final[19].cantidad,
                dia_20: obj.demanda_final[20].cantidad
            })
        })

        let indice_row = 1;  // Contador para los renglones del archivo.
        Object.entries(datos_variables).forEach(arr => {
            ws.getRow(indice_row).getCell(1).value = arr[0];
            ws.getCell(`A${indice_row}`).style = styleFormat;
            ws.getRow(indice_row).getCell(2).value = arr[1];
            indice_row += 1;
        })

        wb.creator = 'Pedido Sugerido';
        wb.title = `Archivo para ver la fuente de demanda`;

        wb.xlsx.writeBuffer()
            .then(buffer => {
                var datos = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                saveAs(datos, `Fuente de demanda.xlsx`);
            })
    }

    render() {
        const columnasCategorias = [
            {
                title: "Código",
                dataIndex: "articulo_codigo",
                key: "articulo_codigo"
            },
            {
                title: "Descripción",
                dataIndex: "articulo_descripcion",
                key: "articulo_descripcion"
            },
            {
                title: "UDMP",
                dataIndex: "unidad_medida",
                key: "unidad_medida"
            },
            {
                title: "Estatus",
                dataIndex: "estatus_nombre",
                key: "estatus_nombre"
            },
            {
                title: "Inv. interno",
                dataIndex: "inv_interno",
                key: "inv_interno"
            },
            {
                title: "Inv. externo",
                dataIndex: "inv_externo",
                key: "inv_externo"
            },
            {
                title: "Pedidos en tránsito",
                dataIndex: "pedidos_en_transito",
                key: "pedidos_en_transito"
            },
            {
                title: "Cantidad en pedidos",
                dataIndex: "cantidad_en_pedidos",
                key: "cantidad_en_pedidos"
            },
            {
                title: "Mínimo estándar BP",
                dataIndex: "minimo_estandar_bp",
                key: "minimo_estandar_bp"
            },
            {
                title: "Inv. teórico",
                dataIndex: "inv_teorico",
                key: "inv_teorico"
            },
            {
                title: "Días inv. teórico",
                dataIndex: "dias_inv_teorico",
                key: "dias_inv_teorico"
            },
            {
                title: "Demanda promedio",
                dataIndex: "demanda_promedio",
                key: "demanda_promedio"
            },
            {
                title: "Stock de seguridad",
                dataIndex: "stock_seguridad",
                key: "stock_seguridad"
            },
            {
                title: "Pedido sugerido",
                dataIndex: "pedido_sugerido",
                key: "pedido_sugerido"
            }
        ]

        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo fuente de demanda"
            >
                <div className="panel-block">
                    <Row gutter={12}>
                        <Col span={8}>
                            <div className="center">Región:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una región">
                                <Select
                                    id="select-region-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    onChange={this.handleChangeRegion}
                                    value={this.state.regionSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrRegiones.length > 0 &&
                                        this.state.arrRegiones.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre_corto}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={8}>
                            <div className="center">Sucursal:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una sucursal">
                                <Select
                                    id="select-sucursal-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.regionSelected === null ? true : false}
                                    onChange={this.handleChangeSucursal}
                                    value={this.state.sucursalSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrSucursales.length > 0 &&
                                        this.state.arrSucursales.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={8}>
                            <div className="center">Plaza:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una plaza">
                                <Select
                                    id="select-plaza-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.sucursalSelected === null ? true : false}
                                    onChange={this.handleChangePlaza}
                                    value={this.state.plazaSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrPlazas.length > 0 &&
                                        this.state.arrPlazas.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                    </Row> <br />
                    <Row gutter={12}>
                        <Col span={8}>
                            <div className="center">Drive:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione drive">
                                <Select
                                    id="select-drive-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.plazaSelected === null ? true : false}
                                    onChange={this.handleChangeDrive}
                                    value={this.state.drivesSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrDrives.length > 0 &&
                                        this.state.arrDrives.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={8}>
                            <div className="center">Categoría:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una categoría">
                                <Select
                                    id="select-categoria-fuente-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.drivesSelected === null ? true : false}
                                    onChange={this.handleChangeCategoria}
                                    value={this.state.categoriaSelected}
                                    allowClear
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrCategorias.length > 0 &&
                                        this.state.arrCategorias.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.descripcion}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={2}>
                            <Tooltip placement="top" title={this.state.plazaSelected !== null ? "Realizar búsqueda" : ""}>
                                <Button
                                    id="boton-filtrar-fuente-demanda"
                                    className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                    type={this.state.disableApplyFilters ? "default" : "primary"}
                                    icon="search"
                                    style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                                    onClick={this.cargarFuenteDemanda}
                                >
                                </Button>
                            </Tooltip>
                        </Col>
                        <Col span={2}>
                            <Tooltip placement="top" title="Borrar filtros">
                                <Button
                                    id="boton-borrar-filtros-fuente-demanda"
                                    type="default"
                                    icon="delete"
                                    className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                    style={{ width: '100%', marginBottom: "30px", marginTop: '1.85em' }}
                                    onClick={this.cleanFilters}
                                >
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                    <Row gutter={12} className={this.state.arrFuenteDemanda.length ? '' : 'display-none'}>
                        <Col span={12} >
                            <Tooltip placement="top" title="Buscar en fuente de demanda">
                                <div className="center">Buscar en fuente de demanda:</div>
                                <Input
                                    id="input-buscar-fuente-demanda-modulo"
                                    type="text"
                                    maxLength={80}
                                    autoFocus
                                    value={this.state.filterText}
                                    placeholder="Buscar por Código / Descripción"
                                    onChange={(e) => this.filterText(e.currentTarget.value)}
                                />
                            </Tooltip>
                        </Col>
                        <Col span={12} >
                            <Tooltip placement="top" title="Descargar a Excel">
                                <div className="center">Descargar a Excel:</div>
                                <Button
                                    className="btnVerCrearGuardar"
                                    type="primary"
                                    id="boton-descargar-demanda-excel"
                                    disabled={this.state.disableBtnContinuar}
                                    onClick={() => {
                                        this.descargarFuenteDemanda()
                                    }}
                                >
                                    Descargar demanda
                    </Button>
                            </Tooltip>
                        </Col>
                    </Row> <br />
                    <Row gutter={12} className={this.state.variablesModeloPedido !== undefined ? '' : 'display-none'}>
                        <Col span={2}>
                            <div className="center">Modelo:</div>
                            <Input
                                id="input-modelo-fuente-demanda-variables"
                                type="text"
                                value={this.state.variablesModeloPedido !== undefined && this.state.variablesModeloPedido.tipo_modelo_nombre}
                                className='disableBtn'
                            />
                        </Col>
                        <Col span={5}>
                            <div className="center">Tiempo de entrega (días):</div>
                            <Input
                                id="tiempo-entrega-variables-fuente-demanda"
                                type="text"
                                value={this.state.variablesModeloPedido !== undefined && this.state.variablesModeloPedido.variables_modelo.tiempo_entrega}
                                className='disableBtn'
                            />
                        </Col>
                        <Col span={6}>
                            <div className="center">Tiempo máximo de entrega (días):</div>
                            <Input
                                id="tiempo-maximo-entrega-variables-fuente-demanda"
                                type="text"
                                value={this.state.variablesModeloPedido !== undefined && this.state.variablesModeloPedido.variables_modelo.tiempo_max_entrega}
                                className='disableBtn'
                            />
                        </Col>
                        <Col span={5}>
                            <div className="center">Frecuencia visita semanal:</div>
                            <Input
                                id="frecuencia-visita-semanal-variables-fuente-demanda"
                                type="text"
                                value={this.state.variablesModeloPedido !== undefined && this.state.variablesModeloPedido.variables_modelo.frecuencia_visita}
                                className='disableBtn'
                            />
                        </Col>
                        <Col span={6}>
                            <div className="center">% incremento por eventualidad:</div>
                            <Input
                                id="incremento-eventualidad-variables-fuente-demanda"
                                type="text"
                                value={this.state.variablesModeloPedido !== undefined && `${this.state.variablesModeloPedido.variables_modelo.incremento_eventualidad.valor}%`}
                                className='disableBtn'
                            />
                        </Col>
                    </Row>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={categoria => categoria.id}
                            columns={columnasCategorias}
                            dataSource={this.state.arrFuenteDemandaCopy}
                            pagination={{ showTitle: false }}
                            scroll={{ x: 1300 }}
                        />
                    </Spin>
                </div>
            </ResponsiveCard>
        )
    }
}